import { useState } from 'react';
import { reviewQuotes } from '@/mocks/articles';

export default function ReviewSection() {
  const [current, setCurrent] = useState(0);

  const prev = () => setCurrent((p) => (p === 0 ? reviewQuotes.length - 1 : p - 1));
  const next = () => setCurrent((p) => (p === reviewQuotes.length - 1 ? 0 : p + 1));

  const quote = reviewQuotes[current];

  return (
    <section className="w-full py-16 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row gap-10 lg:gap-16 items-center">
          {/* Left - Image */}
          <div className="w-full lg:w-[38%]">
            <div className="relative w-full aspect-[4/5] max-w-sm mx-auto lg:max-w-none rounded-2xl overflow-hidden bg-accent-200">
              <img
                src={quote.avatarUrl}
                alt={quote.author}
                title={`911爆料网 - ${quote.author}`}
                className="w-full h-full object-cover"
              />
            </div>
          </div>

          {/* Right - Content */}
          <div className="w-full lg:w-[58%]">
            <span className="inline-block text-xs font-medium text-primary-500 mb-4 px-3 py-1 bg-primary-50 rounded-full">
              网友锐评
            </span>

            <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 leading-tight mb-2">
              每一个爆料背后
            </h2>
            <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-400 leading-tight mb-10">
              都有真相在等待
            </h2>

            {/* Quote */}
            <blockquote className="mb-8">
              <i className="ri-double-quotes-l text-3xl text-primary-200 block mb-2"></i>
              <p className="text-foreground-700 text-base md:text-lg leading-relaxed">
                {quote.quote}
              </p>
            </blockquote>

            {/* Author */}
            <div className="mb-10">
              <span className="block text-foreground-900 font-semibold text-sm">
                — {quote.author}
              </span>
              <span className="block text-foreground-500 text-xs mt-1">
                {quote.role}
              </span>
            </div>

            {/* Navigation Arrows */}
            <div className="flex items-center gap-3">
              <button
                onClick={prev}
                className="w-10 h-10 flex items-center justify-center rounded-full border border-foreground-300 text-foreground-500 hover:border-foreground-400 hover:text-foreground-700 transition-all cursor-pointer"
                aria-label="上一条"
              >
                <i className="ri-arrow-left-line"></i>
              </button>
              <button
                onClick={next}
                className="w-10 h-10 flex items-center justify-center rounded-full bg-foreground-900 text-background-50 hover:bg-foreground-800 transition-all cursor-pointer"
                aria-label="下一条"
              >
                <i className="ri-arrow-right-line"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}